"use client";

import React from "react";
import { withRef, withVariants } from "@udecode/cn";
import { PlateElement } from "@udecode/plate-common";
import { cva } from "class-variance-authority";
import { headingStyles } from "@/components/cms/ContentEditor/config/style.config";

const headingVariants = cva("", {
	variants: {
		variant: headingStyles,
		isFirstBlock: {
			true: "",
			false: "",
		},
	},
});

const HeadingElementVariants = withVariants(PlateElement, headingVariants, [
	"isFirstBlock",
	"variant",
]);

// @ts-ignore
export const HeadingElement = withRef<typeof HeadingElementVariants>(
	({ variant = "h1", isFirstBlock, children, ...props }, ref) => {
		const { element, editor } = props;

		const Element = variant!;

		return (
			<HeadingElementVariants
				ref={ref}
				asChild
				variant={variant}
				isFirstBlock={element === editor.children[0]}
				{...props}
			>
				<Element>{children}</Element>
			</HeadingElementVariants>
		);
	}
);
